import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/personnels/PersonnelsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import "../../../../../../_metronic/_assets/sass/pages/wizard/wizard-4.scss";
import KTWizard from "../../../../../../_metronic/_assets/js/components/wizard";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { PersonnelEditForm } from "./PersonnelEditForm";

export function PersonnelEdit({
  history,
  match: {
    params: { id }
  }
}) {
  // Subheader
  const suhbeader = useSubheader();
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, personnel } = useSelector(
    (state) => ({
      actionsLoading: state.personnels.actionsLoading,
      isSuccess: state.personnels.isSuccess,
      type: state.personnels.type,
      personnel: state.personnels.personnel
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getPersonnel(id));
    return () => dispatch(actions.cleanPersonnelsState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Personel";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    suhbeader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  /** Belli Bir Personeli Kaydeder */
  const savePersonnel = (formData) => {
    dispatch(actions.savePersonnel(formData)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/personeller"), 2500);
  };

  const btnRef = useRef();  
  const savePersonnelClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  // Personnel Form Wizard
  const options = {
    startStep: 1,
    clickableSteps: true
  };

  new KTWizard(document.querySelector("#personnel_form_wizard"), options);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <PersonnelEditForm
          personnel={personnel}
          btnRef={btnRef}
          savePersonnel={savePersonnel}
        />         
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={savePersonnelClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}